<template>
	<div>
		<b-alert
			v-if="addRefError"
			:show="dismissCountDown"
			dismissible
			style="margin-bottom: 10px;"
			variant="warning"
			size="sm"
			@dismissed="dismissCountDown=0"
			@dismiss-count-down="countDownChanged"
		>
			<p v-for="(message, index) in addRefErrorMessages"
			   :key="'message'+index">
				{{ $t( message ) }}
			</p>
		</b-alert>
		<div>
			<p v-if="refInputNotFilled" style="color: red;">{{ $t('please-title') }}</p>

			<b-form-group label-cols="4"
						  label-cols-lg="2"
						  label-size="sm"
						  :label="$t('reference.create.name')"
						  label-for="refName"
						  class="required"
			>
				<b-form-input :required="true"
							  data-errormessage-value-missing="Это поле обязательно для заполнения!"
							  id="childRefName" size="sm" v-model="item.name" ref="childRefName"
							  :placeholder="$t('reference.create.name')"/>
			</b-form-group>

			<b-form-group label-cols="4"
						  label-cols-lg="2"
						  label-size="sm"
						  :label="$t('reference.create.code')"
						  label-for="childRefCode"
						  class="required"
			>
				<b-form-input :required="true"
							  data-errormessage-value-missing="Это поле обязательно для заполнения!"
							  id="childRefCode" size="sm" v-model="item.code"
							  :placeholder="$t('reference.create.code')"/>
			</b-form-group>

			<b-form-group label-cols="4" label-cols-lg="2" label-size="sm" :label="$t('reference.create.value')"
						  label-for="childRefValue">
				<b-form-input id="childRefValue" size="sm" v-model="item.value"
							  :placeholder="$t('reference.create.value')"/>
			</b-form-group>

			<b-form-group label-cols="4" label-cols-lg="2" label-size="sm" :label="$t('reference.create.sort')"
						  label-for="childRefSort">
				<b-form-input id="childRefSort" size="sm" type="number" v-model="item.sort"
							  :placeholder="$t('reference.create.sort')"/>
			</b-form-group>

			<b-form-group label-cols="4" label-cols-lg="2" label-size="sm" :label="$t('mxikCode')"
						  label-for="childRefMxikCode">
				<b-form-input id="childRefSort" size="sm" v-model="item.mxikCode"
							  :placeholder="$t('mxikCode')"/>
			</b-form-group>

			<div class="row mt-3 createRoleModalButtons justify-content-end">
				<div class="col-4">
					<b-button variant="outline-danger" size="sm" block @click="emitCloseUpdateRefModal">{{ $t('actions.cancel') }}</b-button>
				</div>
				<div class="col-4">
					<b-button variant="outline-success" size="sm" block @click="saveRef">{{ $t('actions.save') }}</b-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapState, mapActions, mapGetters} from 'vuex'

	const itemInitial = {
		id: null,
		parentId: null,
		parentName: '',
		code: '',
		name: '',
		value: '',
		sort: null,
		mxikCode: ''
	};
	export default {
		name: "CreateRefModalContent",
		props: {
			parent: {
				type: String,
				default: ''
			},
			parentCode: {
				type: String,
				default: ''
			},
			propItem: {
				type: Object,
				default: () => {}
			},
		},

		data: () => {
			return {
				dismissCountDown: 4,
				refInputNotFilled: false,
				responceError: false,
				item: Object.assign({}, itemInitial),
			}
		},
		watch: {
			'parentCode': {
				handler() {
					this.refInputNotFilled = false;
					this.item = Object.assign({}, itemInitial);
				}
			}
		},
		computed: {
			...mapState('references', [
				'addRefErrorMessages', 'addRefError'
			]),
			...mapGetters('references', [
				'getReferences'
			])
		},
		/**
		 * Methods
		 */
		methods: {
			...mapActions('references', [
				'getReferenceChildren', 'updateOrCreateRefChild'
			]),
			countDownChanged(dismissCountDown) {
				if (dismissCountDown <= 1) {
					dismissCountDown = 3;
				}
				this.dismissCountDown = dismissCountDown
			},
			focusName() {
				this.$refs.childRefName.focus();
			},
			async emitCloseUpdateRefModal() {
				this.refInputNotFilled = false;
				await this.$emit('closeUpdateRefModal');
				this.item = Object.assign({}, itemInitial);
			},
			async saveRef() {
				if (this.item.name.trim() != '' && this.item.code.trim() != '') {
					let parentRef = this.getReferences.find((el) => {
						return el.code.toUpperCase() === this.parentCode.toUpperCase()
					});
					this.item.parentId = parentRef.id;
					this.item.parentName = parentRef.name;
					this.refInputNotFilled = false;
					await this.updateOrCreateRefChild(this.item);
					if (this.addRefError) {
						await setTimeout(() => {
							this.$store.commit('references/addRefError', {message: '', boolean: false})
						}, 4000)
					} else {
						await this.getReferenceChildren(parentRef.code);
						this.item = Object.assign({}, itemInitial);
						this.emitCloseUpdateRefModal()
					}
				} else {
					this.refInputNotFilled = true;
				}
			},
		},
	}
</script>

<style scoped>

</style>
